import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { GENIE_AVATAR_WRAPPER_DIMENSION, GENIE_TRANSLATE, MAX_VISIBLE_GENIES } from "constants/index"
import { updateShowGeniesList } from "appRedux/slices/wishListSlice"
import Avatars from "components/atoms/Avatars"
import ItemCard from "components/molecules/ItemCard"

export default function FeedTrueWishSummary(props: TrueWish) {
  const { id, name, image, genies, user } = props

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  function handleNavigateToItem() {
    navigate(`/user/${props.user?.handle}/item/${id}`)
  }

  function handleVisitGenies() {
    if (genies.length > 1) {
      dispatch(updateShowGeniesList(true))
    }
    navigate(`/user/${props.user?.handle}/item/${id}`)
  }

  const width = useMemo(() => {
    const visibleAvatarsCount = Math.min(genies.length, MAX_VISIBLE_GENIES)
    return (visibleAvatarsCount * GENIE_AVATAR_WRAPPER_DIMENSION - ((visibleAvatarsCount - 1) * GENIE_TRANSLATE) + 8) // 8 is due to the padding (4 * 2) for AvatarsWrapper component

  }, [genies])

  function genieIsItemOwner() {
    if (genies.length > 1) return false
    return genies[0].handle === user.handle
  }

  return (
    <Stack gap="8px">
      <ItemCard
        name={name}
        image={image}
        onItemClick={handleNavigateToItem}
      >
        <GeniesSection onClick={handleVisitGenies}>
          {genieIsItemOwner() ? <Text>{t("items.purchased")}</Text> : <AvatarsWrapper style={{
            width: width
          }}>
            <Avatars type={"linear"} users={[...genies]}/>
          </AvatarsWrapper>}
        </GeniesSection>
      </ItemCard>
    </Stack>
  )
}

const GeniesSection = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.primary["5"],
  borderRadius: "32px",
  marginTop: "auto",
  marginLeft: "auto",
  marginRight: "10px"
}))

const Text = styled(Typography)(({ theme }) => ({
  padding: "8px 16px",
  fontSize: "1.2rem",
  color: theme.palette.primary["1"]
}))

const AvatarsWrapper = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.primary["5"],
  padding: "4px",
  borderRadius: "32px",

  "& > div": {
    justifyContent: "flex-start"
  }
}))
